<template>
  <div class="container">
    <head-nav-bar :title="title" :fixed="true" @click-left="$router.go(-1)" />
    <div class="mt-header-nav">
      <van-cell-group>
        <van-field
          v-model="form.CardNo"
          readonly
          required
          label="会员卡号："
          placeholder="点击此处选择"
          right-icon="arrow"
          @click="showMemberCard"
        />
        <van-cell v-if="memberInfo && memberInfo.Id">
          <template #title>
            <span>
              {{ memberInfo.Name }}
              <van-tag plain>{{ memberInfo.MemberCardTypeName }}</van-tag>
            </span>
          </template>
          <template #label>
            <van-row>
              <van-col span="12">余额：{{ memberInfo.Balance }}</van-col>
              <van-col span="12"
                >积分余额：{{ memberInfo.PointBalance }}</van-col
              >
            </van-row>
          </template>
        </van-cell>
      </van-cell-group>
      <money-input
        v-model="form.Amount"
        required
        label="金额"
        placeholder="充值金额"
      ></money-input>

      <form-select
        label="付款方式"
        v-model="form.PaywayId"
        valueKey="Id"
        textKey="Text"
        :required="true"
        defaultValue="1"
        :columns="selectData.PaywayList"
      ></form-select>

      <van-cell-group>
        <van-field
          v-model="form.PresentAmount"
          label="赠送金额："
          placeholder="请输入"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="form.PresentPoint"
          label="赠送积分："
          placeholder="请输入"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="form.Remark"
          rows="2"
          label="备注信息："
          type="textarea"
          placeholder="请输入备注信息"
          show-word-limit
        />
      </van-cell-group>

      <div class="box" style="margin-top:0.5rem">
        <van-button type="info" block :disabled="disabled" @click="onSubmit"
          >确认充值</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  Field,
  Cell,
  CellGroup,
  NoticeBar,
  Button,
  Toast,
  Notify,
  RadioGroup,
  Radio,
  Tag,
  Row,
  Col,
} from "vant";
import { getMemberInfo, memberRecharge } from "@/api/member.js";
import { getSelectData } from "@/api/common.js";
import selectMember from "@/components/select-member/function.js";
import moneyInput from "@/components/moneyInput";
import formSelect from "@/components/form-select/index.js";

export default {
  name: "Member",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [NoticeBar.name]: NoticeBar,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Tag.name]: Tag,
    [Row.name]: Row,
    [Col.name]: Col,
    moneyInput,
    formSelect,
  },
  data() {
    return {
      title: "会员充值",
      selectData: {
        PaywayList: [],
      },
      disabled: false,
      CardData: {},
      memberInfo: {},
      form: {
        MemberCardId: "",
        CardNo: "",
        Amount: "",
      },
    };
  },
  created() {
    this.id = this.$route.query.Id;
    this.getSelectData();
  },
  methods: {
    //获取下拉数据
    getSelectData() {
      if (this.id) {
        //查询会员明细
        getMemberInfo({
          Id: this.id,
        }).then(res => {
          this.memberInfo = res.Data;
          this.form.MemberCardId = this.memberInfo.Id;
          this.form.CardNo = this.memberInfo.CardNo;
        });
      }
      //获取付款方式
      getSelectData({
        Types: "payway",
      }).then(res => {
        this.selectData.PaywayList = res.Data.payway;
      });
    },
    //显示会员卡选择器
    showMemberCard() {
      const _this = this;
      selectMember({
        change: info => {
          //查询会员明细
          getMemberInfo({
            Id: info.Id,
          }).then(res => {
            _this.memberInfo = res.Data;
          });
          _this.form.MemberCardId = info.Id;
          _this.form.CardNo = info.CardNo;
        },
      });
    },

    onSubmit() {
      //验证
      const verifyRes = this.verifyForm();
      if (verifyRes === false) {
        return false;
      }
      const json = {
        ...this.form,
        MemberRechargePlanId:
          this.memberInfo.MemberRechargePlan &&
          this.memberInfo.MemberRechargePlan.Id
            ? this.memberInfo.MemberRechargePlan.Id
            : 0,
        Category: 1,
        PointCategory: 4,
      };

      memberRecharge(json).then(() => {
        Toast.success("充值成功");
        let form = {};
        for (const key in this.form) {
          form[key] = "";
        }
        this.form = form;
        this.memberInfo = {};
      });
    },
    verifyForm() {
      const verifyFields = ["CardNo", "Amount", "PaywayId"];
      let is = false;
      for (let i = 0; i < verifyFields.length; i++) {
        const item = verifyFields[i];
        if (!this.form[item]) {
          is = true;
        }
      }
      if (is) {
        Notify("带*号必填，请完善信息！");
        return false;
      }

      return true;
    },
  },
};
</script>

<style></style>
